export default __webpack_public_path__ + "static/media/Formular.98ea2d89.svg";